import { useEffect } from "react"
import { LoaderCircle } from "lucide-react"
import WeekCalendar from "@/modules/calendar/components/week-calendar/week-calendar"
import type { UserEventForm } from "@/modules/calendar/types/user-event-form"
import UserEventSideSheet from "@/modules/calendar/components/user-event-side-sheet/user-event-side-sheet"
import EventModal from "@/modules/calendar/components/event-modal/event-modal"
import useCalendarConfig from "@/modules/calendar/stores/use-calendar-config"
import useGetCalendarRangesInfo from "@/modules/calendar/queries/use-get-calendar-ranges-info"
import { useForm, FormProvider } from "react-hook-form"
import extractISODate from "@/modules/calendar/utils/extract-iso-date"
import { PRODUCT_TOUR_STEPS } from "@/modules/product-tour/constants/steps"

export default function CalendarLayout() {
  const { isPending, isError, data, error, isSuccess } = useGetCalendarRangesInfo()
  const { setRanges, ranges, setCurrentWeek, setCurrentDate } = useCalendarConfig()
  const { startDate, endDate } = ranges
  const methods = useForm<UserEventForm>()

  useEffect(() => {
    if (isSuccess && data) {
      const { startDate, endDate } = data.data.description
      const today = new Date()
      setCurrentDate(extractISODate(today))
      setCurrentWeek(today.toISOString())

      setRanges({
        startDate: startDate,
        endDate: endDate,
        startTime: "00:00",
        endTime: "23:30",
      })
    }
  }, [data])

  return (
    <section
      className="size-full max-h-full overflow-hidden p-6"
      id={PRODUCT_TOUR_STEPS.AGENDA_START}
    >
      <h2 className="mb-3 text-3xl font-bold">Agenda</h2>
      <div
        className="mx-auto my-0 size-full overflow-hidden pb-6"
        id={PRODUCT_TOUR_STEPS.AGENDA_EDIT_EVENT}
      >
        {isPending ? (
          <div className="mt-36 flex items-center justify-center">
            <LoaderCircle className="!size-10 animate-spin" />
          </div>
        ) : isError ? (
          <p className="mt-36 flex w-full flex-col items-center gap-3">
            <span>Algo salió mal</span>
            <span>{error?.message}</span>
          </p>
        ) : startDate && endDate ? (
          <FormProvider {...methods}>
            <WeekCalendar />
            <UserEventSideSheet />
            <EventModal />
          </FormProvider>
        ) : null}
      </div>
    </section>
  )
}
